import { makeStyles } from '@material-ui/styles';

export default makeStyles(
    {
        align: {
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'end',
            height: '80px'
        },
        uuid: {
            display: 'block',
            fontSize: '11px',
            textAlign: 'right'
        }
    },
);